// extracted by mini-css-extract-plugin
export default {"cartList":"Cart_cartList__glMQe","header":"Cart_header__xeUGN","total":"Cart_total__iYXgy","noItems":"Cart_noItems__qicfS"};